
      <!--  OVERLAY  -->

      <div class="overlay" [class.show]="uiModal.show" [class.can-dismiss]="uiModal.canDismiss" [class.opaque]="uiModal.opaque" (click)="onClose()"></div>

      <!--  END OVERLAY  -->

      <!--  MODAL  -->

      <div class="modal"
           [class.has-footer]="uiModal.actions.length"
           [class.has-tabs]="uiTabBar"
           [class.light-body]="uiModal.baseTheme === 'light'"
           [ngClass]="'width-' + uiModal.width + ' position-' + uiModal.position + ' height-' + uiModal.height"
           [@modal]="modalState"
           (@modal.done)="onAnimationEnd($event)">

          <!--  MODAL HEADER  -->

          <div class="modal-header" [class.can-dismiss]="uiModal.canDismiss">

              <!--  TITLE  -->

              <h2>{{ uiModal.title }}</h2>

              <!--  END TITLE  -->

              <!--  DISMISS BUTTON  -->

              <a class="icon-button" (click)="onClose()">
                  <i class="far fa-times"></i>
              </a>

              <!--  END DISMISS BUTTON  -->

          </div>

          <!--  END MODAL HEADER  -->

          <!--  TABS  -->

          <div *ngIf="uiTabBar" class="modal-tabs">
              <ui-tab-bar [uiTabBar]="uiTabBar"></ui-tab-bar>
          </div>

          <!--  END TABS  -->

          <!--  MODAL BODY  -->

          <div #modalBody id="modalBody" class="modal-body">
              <router-outlet></router-outlet>
          </div>

          <!--  END MODAL BODY  -->

          <!--  MODAL FOOTER  -->

          <div *ngIf="uiModal.actions.length" class="modal-footer" [ngClass]="'actions-position-' + uiModal.actionsPosition">

              <!--  MODAL ACTION LOOP  -->

              <ng-template ngFor [ngForOf]="uiModal.actions" let-action>

                  <!--  BUTTON  -->

                  <a *ngIf="action.type === 'button'" class="button" [ngClass]="action.theme + '-button'" [uiLoading]="action.showWorking && action.working" (click)="onClick(action)"> {{ action.text }} </a>

                  <!--  END BUTTON  -->

                  <!--  ANCHOR BUTTON  -->

                  <a *ngIf="action.type === 'anchorButton'" class="button" [ngClass]="action.theme + '-button'" [attr.href]="action.href" [attr.target]="action.target">{{ action.text }}</a>

                  <!--  END ANCHOR BUTTON  -->

                  <!--  ROUTER BUTTON  -->

                  <a *ngIf="action.type === 'routerButton'" class="button" [ngClass]="action.theme + '-button'" (click)="onRouterButtonClick(action.navigateTo)">{{ action.text }}</a>

                  <!--  END ROUTER BUTTON  -->

              </ng-template>

              <!--  END MODAL ACTION LOOP  -->

          </div>

          <!--  END MODAL FOOTER  -->

      </div>

      <!--  END MODAL  -->
    